module.exports = __webpack_public_path__ + "assets/img/icon19.badeb4e1.png";